<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';
import { defineEmits } from 'vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div class="text-sm">
    <button
      class="flex items-center select-none w-full bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 cursor-pointer justify-between py-3 px-4 drag-handle transition-colors duration-200 group"
      @click.stop="onToggle"
    >
      <div class="flex items-center gap-3 mb-0">
        <EmojiOrIcon 
          v-if="icon || emoji"
          class="inline-block w-5 h-5 text-slate-600 dark:text-slate-400" 
          :icon="icon" 
          :emoji="emoji" 
        />
        <h5
          class="text-slate-800 text-sm font-medium dark:text-slate-200 mb-0"
        >
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row items-center gap-2">
        <slot name="button" />
        <div class="flex w-6 h-6 items-center justify-center">
          <fluent-icon 
            v-if="isOpen" 
            size="16" 
            icon="chevron-up" 
            type="outline" 
            class="text-slate-600 dark:text-slate-400"
          />
          <fluent-icon 
            v-else 
            size="16" 
            icon="chevron-right" 
            type="outline" 
            class="text-slate-600 dark:text-slate-400"
          />
        </div> 
      </div>
    </button>
    <div
      v-if="isOpen"
      class="bg-slate-50 dark:bg-slate-800"
      :class="compact ? 'p-0' : 'px-4 pb-4'"
    >
      <slot />
    </div>
  </div>
</template>
